import { Button, StatusPage, TOUCH } from "@nymbl/nos2-rules";
import { useRouter } from "@tanstack/react-router";
import { PersonAccessError, useCurrentPerson } from "@/hooks/use-current-person";
import { signOut, useSession } from "@/lib/auth-client";
import { queryClient } from "@/lib/query";

/** Where `requirePerson` sends someone the warehouse can't match to one active Person. */
export function NoAccessPage() {
  const router = useRouter();
  const { error } = useCurrentPerson();
  const { data: session } = useSession();
  const isAdmin = session?.user.role === "admin";
  const message =
    error instanceof PersonAccessError
      ? error.message
      : "Your sign-in isn't linked to a Nymbl person.";

  async function handleSignOut() {
    await signOut();
    queryClient.clear();
    router.navigate({ to: "/login" });
  }

  return (
    <StatusPage
      kind="no-access"
      message={message}
      actions={
        <>
          {isAdmin && (
            <Button
              variant="outline"
              className={TOUCH}
              onClick={() => router.navigate({ to: "/dashboard/settings" })}
            >
              Settings
            </Button>
          )}
          <Button className={TOUCH} onClick={handleSignOut}>
            Sign out
          </Button>
        </>
      }
    />
  );
}
